import { Actor, fetchCandid } from '@icp-sdk/core/agent'
import { Principal } from '@icp-sdk/core/principal'
import { config } from '@plug-core/appConfig'

export const getCandid = async (canisterId: Principal): Promise<string> => {
  const agent = config.getAgent()

  return (
    (await fetchCandid(canisterId.toText(), agent)) ??
    ((await Actor.createActor(
      (idl) =>
        idl.IDL.Service({
          __get_candid_interface_tmp_hack: idl.IDL.Func([], [idl.IDL.Text], ['query']),
        }),
      { agent, canisterId }
    ).__get_candid_interface_tmp_hack()) as string)
  )
}
